class FlProgressBarClone extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => {
      const source = document.querySelector('fl-progress-bar');
      if (source) {
        const clone = source.cloneNode(true);
        this.appendChild(clone);
      }
    });
  }
}

if (!customElements.get('fl-progress-bar-clone')) {
  customElements.define('fl-progress-bar-clone', FlProgressBarClone);
}